module.exports = __webpack_public_path__ + "img/space.042a211a.svg";